import { memo } from "react";
import styled from "styled-components";

const StyledTableRow = styled.tr`
  margin: 0;
  padding: 0;

  border-bottom: 1px solid #ebebeb;

  /* Selected state */
  background-color: ${({ $selected }) => ($selected ? "#f3f9ff" : "transparent")};
  box-shadow: ${({ $selected }) =>
    $selected ? "0 0 0 2px #dbeafe inset" : "none"};

  transition: background-color 0.18s ease, box-shadow 0.18s ease;

  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};

  /* Hover state */
  &:hover {
    background-color: ${({ $selected }) =>
    $selected ? "#e6f2ff" : "#f5f5f5"};
    box-shadow: ${({ $selected }) =>
    $selected ? "0 0 0 2px #bfdbfe inset" : "0 0 0 1.5px #d1d5db inset"};
  }

  /* Striped rows */
  &:nth-child(even) {
    background-color: ${({ $striped, $selected }) =>
    $striped && !$selected ? "#fafafa" : undefined};
  }

  /* ALL table cells inside this row */
  td {
    padding: 10px 12px;
    vertical-align: middle;

    /* Prevent long text from stretching table */
    max-width: var(--td-max-width, 200px);  /* default 200px */
    white-space: normal;
    word-break: normal;  
    overflow-wrap: normal;
  }

  &:last-child {
    border-bottom: 0;
  }
`;

const TableRow = memo(({ children, isSelected = "No", striped = false, ...rest }) => (
  <StyledTableRow
    $selected={isSelected === "Yes"}
    $striped={striped}
    {...rest}
  >
    {children}
  </StyledTableRow>
));

export default TableRow;
